export const accessibiliteData = [
    {
        // title: "Déclaration d'accessibilité",
        content: `L’accessibilité numérique consiste à rendre les services de communication au public en ligne accessibles aux personnes handicapées, c’est-à-dire perceptibles, utilisables, compréhensibles et robustes.
        <br/><br/>
        AbbVie s’engage à rendre ses sites Web (internet, intranet et extranet), ses progiciels et ses applications les accessibles conformément à l’article 47 de la loi n°2005-102 du 11 février 2005.
        <br/><br/>
        Cette déclaration d’accessibilité s’applique à <a href="https://www.cartessurtable-vhc.fr/">cartessurtable-vhc.fr</a>.
        <br/><br/>
        Nous nous engageons à faire en sorte que les sites Web d&#39;AbbVie soient accessibles à tous les
utilisateurs, y compris ceux qui utilisent des technologies d&#39;assistance telles que des lecteurs d&#39;écran.
Nos sites Web sont régulièrement mis à jour et nos efforts pour garantir l&#39;accessibilité et améliorer
l&#39;expérience utilisateur se poursuivent. Si vous rencontrez des difficultés pour accéder à une partie de nos
sites Web ou si vous souhaitez nous faire part de vos commentaires sur la facilité d&#39;utilisation de nos
sites Web, veuillez nous contacter en utilisant l&#39;une des méthodes de contact ci-dessous. Nous
examinerons vos commentaires au fur et à mesure évaluer les moyens d&#39;améliorer l&#39;expérience utilisateur
et de répondre aux besoins de tous les visiteurs de notre site Web et de communiquer efficacement avec
eux.`,
    },
    {
        title: 'Etat de conformité',
        content: `<a href="https://www.cartessurtable-vhc.fr/">cartessurtable-vhc.fr</a> est partiellement conforme avec le référentiel général d’amélioration de
l’accessibilité.`,
    },
    {
        title: 'Résultat des tests',
        content: `L’audit de conformité réalisé en interne révèle que :
        <br/>

<ul><li> 97,4% des critères RGAA sont respectés.</li></ul>
`,
    },
    {
        title: 'Établissement de cette déclaration d’accessibilité',
        content: `AbbVie Inc. prend les mesures suivantes pour garantir l&#39;accessibilité de ses sites Web :
<ul><li> Inclure l&#39;accessibilité dans nos politiques internes.</li>
<li> Nommez un responsable de l&#39;accessibilité et/ou un médiateur.</li>
<li> Réaliser régulièrement des audits complets visant à détecter les domaines à améliorer.</li></ul>`,
    },
    {
        title: 'Spécifications techniques',
        content: `L&#39;accessibilité de nos sites Web repose sur les technologies suivantes pour fonctionner avec la
combinaison particulière du navigateur Web et de toutes les technologies d&#39;assistance ou plugins
installés sur votre ordinateur :
<ul><li>HTML</li>
<li>WAI-ARIA</li>
<li>CSS</li>
<li>JavaScript</li></ul>
Ces technologies sont utilisées pour se conformer aux normes d&#39;accessibilité utilisées.`,
    },
    {
        title: 'Les outils utilisés lors de l’évaluation',
        content: `Siteimprove`,
    },
    {
        title: 'Retour d’information et contact',
        content: `Vos commentaires sur l&#39;accessibilité d&#39;AbbVie.com et des autres sites Web d&#39;AbbVie sont les bienvenus.
Si vous rencontrez des problèmes d&#39;accessibilité sur un site Web d&#39;AbbVie ou si vous avez une
suggestion pour améliorer l&#39;accessibilité ou la convivialité d&#39;un site Web, veuillez nous contacter en
utilisant l&#39;une des méthodes ci-dessous. Assurez-vous de faire référence au site Web concerné et de
décrire la fonctionnalité spécifique qui, selon vous, n&#39;est pas entièrement accessible ou de suggérer une
amélioration :
<ul>
<li><a href="https://www.abbvie.com/contactus.html">Formulaire de contact</a></li>
<li>Adresse électronique : <br/><a href="mailto:webaccessibility@abbvie.com">webaccessibility@abbvie.com</a> </li>
<li>Adresse postale : 1 North Waukegan Road, North Chicago, IL, 60064</li>
</ul>`,
    },
    {
        title: 'Voies de recours',
        content: `Cette procédure est à utiliser dans le cas suivant.
        <br/><br/>
Vous avez signalé au responsable du site internet un défaut d’accessibilité qui vous empêche d’accéder
à un contenu ou à un des services du portail et vous n’avez pas obtenu de réponse satisfaisante.
 <br/><br/>
<ul><li>Écrire un message au <a href="https://formulaire.defenseurdesdroits.fr/formulaire_saisine/">Défenseur des droits</a></li>
<li>Contacter le délégué du <a href="https://formulaire.defenseurdesdroits.fr/formulaire_saisine/">Défenseur des droits</a> dans votre région</li>
<li>Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) :
<ul>
<li>Défenseur des droits</li>
<li>Libre réponse 71120</li>
<li>75342 Paris CEDEX 07</li>
</ul>
</li>
</ul>`,
    },
];
